import React from 'react';

const Location = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.262 29.1">
        <path
            fill="none"
            fillRule="nonzero"
            stroke="currentColor"
            strokeWidth="2.1"
            d="M11.631 1.05C5.79 1.057 1.057 5.888 1.05 11.85c0 4.395 3.125 8.044 6.436 11.906 1.047 1.223 2.132 2.488 3.098 3.768.25.332.637.526 1.047.526.41 0 .797-.194 1.048-.526.965-1.28 2.05-2.545 3.097-3.768 3.31-3.862 6.436-7.511 6.436-11.906-.006-5.962-4.74-10.793-10.58-10.8Zm.365 15.324a4.378 4.378 0 1 1 0-8.756 4.378 4.378 0 0 1 0 8.756Z"
        />
    </svg>
);

export default Location;
